import { useEffect, useState } from 'react';
import { GeoItem } from 'src/models/geoItem';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useProjectVillages = (projectId: number | null | undefined, communeId: number | null | undefined) => {
  const [villages, setVillages] = useState<GeoItem[]>([]);
  const [loading, setLoading] = useState(false);
  const httpClient = useHttpClient(true);

  useEffect(() => {
    if (!projectId || !communeId) {
      setVillages([]);
      return;
    }

    const fetchVillages = async () => {
      setLoading(true);
      try {
        const response = await httpClient.current?.get(`/api/project/${projectId}/communes/${communeId}/villages`);
        setVillages(response?.data || []);
      } finally {
        setLoading(false);
      }
    };

    fetchVillages();
  }, [httpClient, projectId, communeId]);

  return { villages, loading };
};
